export default {
    setZoomConfigurations,
    getZoomConfig,
    getDeviceLayerMinZoom,
    getVehicleLayerMinZoom
}

// Default values from original map implementation.
const defaultConfig = {
    minZoom: 0,
    deviceLayerVisible: true,
    vehicleLayerVisible: true,
    vehicleIconVisible: true,
    vehicleInfoVisible: true,
    vehicleCircleRadius: 20,
    baseBusIcon: {
        scale: 0.42
    },
    baseTramIcon: {
        scale: 0.3
    }
};

// List of settings for different zoom levels that can be overridden by Traveller parameters.
let zoomConfigs = [
    {
        minZoom: 19,
        deviceLayerVisible: true,
        vehicleLayerVisible: true,
        vehicleIconVisible: true,
        vehicleInfoVisible: true,
        vehicleCircleRadius: 20,
        baseBusIcon: {
            scale: 0.42
        },
        baseTramIcon: {
            scale: 0.3
        }
    },
    {
        minZoom: 17,
        deviceLayerVisible: true,
        vehicleLayerVisible: true,
        vehicleIconVisible: true,
        vehicleInfoVisible: true,
        vehicleCircleRadius: 15,
        baseBusIcon: {
            scale: 0.3
        },
        baseTramIcon: {
            scale: 0.22
        }
    },
    {
        minZoom: 14,
        deviceLayerVisible: true,
        vehicleLayerVisible: true,
        vehicleIconVisible: true,
        vehicleInfoVisible: false,
        vehicleCircleRadius: 10,
        baseBusIcon: {
            scale: 0.2
        },
        baseTramIcon: {
            scale: 0.12
        }
    },
    {
        minZoom: 12,
        deviceLayerVisible: true,
        vehicleLayerVisible: true,
        vehicleIconVisible: false,
        vehicleInfoVisible: false,
        vehicleCircleRadius: 5,
        baseBusIcon: {
            scale: 0.2
        },
        baseTramIcon: {
            scale: 0.1
        }
    },
    {
        minZoom: 11,
        deviceLayerVisible: true,
        vehicleLayerVisible: false,
        vehicleIconVisible: false,
        vehicleInfoVisible: false,
        vehicleCircleRadius: 5,
        baseBusIcon: {
            scale: 0.2
        },
        baseTramIcon: {
            scale: 0.1
        }
    },
    {
        minZoom: 0,
        deviceLayerVisible: false,
        vehicleLayerVisible: false,
        vehicleIconVisible: false,
        vehicleInfoVisible: false,
        vehicleCircleRadius: 0,
        baseBusIcon: {
            scale: 0.1
        },
        baseTramIcon: {
            scale: 0.1
        }
    }
];

function setZoomConfigurations(configList) {
    zoomConfigs = { ...configList };
}

function getZoomConfig(zoomLevel) {
    if (zoomConfigs.length > 0) {
        for (const config of zoomConfigs) {
            if (zoomLevel >= config.minZoom) {
                return config;
            }
        }
    }
    return defaultConfig;
}

function getDeviceLayerMinZoom() {
    for (let i = zoomConfigs.length - 1; i >= 0; i--) {
        if (zoomConfigs[i].deviceLayerVisible) {
            return zoomConfigs[i].minZoom;
        }
    }
    return 0;
}

function getVehicleLayerMinZoom() {
    for (let i = zoomConfigs.length - 1; i >= 0; i--) {
        if (zoomConfigs[i].vehicleLayerVisible) {
            return zoomConfigs[i].minZoom;
        }
    }
    return 0;
}